import type { SceneObject } from "./SceneHost";

export type Bounds = { x: number; y: number; w: number; h: number };

export function objectBounds(obj: SceneObject): Bounds {
  return {
    x: obj.x,
    y: obj.y,
    w: typeof obj.w === "number" ? obj.w : 0,
    h: typeof obj.h === "number" ? obj.h : 0,
  };
}

export function unionBounds(objects: SceneObject[]): Bounds | null {
  if (!objects.length) return null;
  let minX = Infinity;
  let minY = Infinity;
  let maxX = -Infinity;
  let maxY = -Infinity;
  for (const obj of objects) {
    const b = objectBounds(obj);
    minX = Math.min(minX, b.x);
    minY = Math.min(minY, b.y);
    maxX = Math.max(maxX, b.x + b.w);
    maxY = Math.max(maxY, b.y + b.h);
  }
  if (!Number.isFinite(minX)) return null;
  return { x: minX, y: minY, w: maxX - minX, h: maxY - minY };
}

export function getHomogeneousType(objects: SceneObject[]): string | null {
  if (!objects.length) return null;
  const t = objects[0].type;
  return objects.every((o) => o.type === t) ? t : null;
}

const MIN_SIZE = 16;

export function clampBounds(b: Bounds): Bounds {
  return {
    x: b.x,
    y: b.y,
    w: Math.max(MIN_SIZE, b.w),
    h: Math.max(MIN_SIZE, b.h),
  };
}
